module.exports = __webpack_public_path__ + "static/javier-615a489d4f041c6996c963800f62974f.png";